import { Field } from 'signer-app/types/editor-types';
import { FieldSave } from 'signer-app/signer-signature-document/types';

export type BackendErrorType = 'authentication-error' | 'generic-error';

export const typeMap: Record<Field['type'], FieldSave['componentType']> = {
  hyperlink: 'inputhyperlink',
  rectangle: 'inputrectangle',
  image: 'inputimage',
  date: 'inputdate',
  dropdown: 'inputdropdown',
  checkbox: 'inputcheckmark',
  radiobutton: 'inputradiobutton',
  initials: 'inputinitials',
  signature: 'inputsignature',
  text: 'inputtextbox',
};

export const signerExperienceQueryKey = (
  signatureRequestId: string,
  accessCode: string | null,
) => ['signer-experience', signatureRequestId, accessCode] as const;
